<template>
  <el-container class="editor-page">
    <el-header height="50px">
      <div class="editor-header">
        <h3 class="editor-title">{{ isEdit ? '编辑条码模板' : '新增条码模板' }}</h3>
        <div class="editor-header-actions">
          <el-button icon="el-icon-refresh-left" class="el-button-undo" @click="handleUndo">撤回</el-button>
          <el-button icon="el-icon-refresh-right" class="el-button-undo" @click="handleRedo">恢复</el-button>
          <el-button type="primary" icon="eye" class="el-button-undo" @click="preView"> 预览 </el-button>
          <!--<el-button @click="handleCancel">取消</el-button>-->
          <el-button type="primary" :loading="saving" @click="handleSave">保存</el-button>
        </div>
      </div>
    </el-header>

    <el-main>
      <!-- 基础信息表单 -->
      <el-form ref="templateForm" :model="form" :rules="formRules" label-width="120px" size="small">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="模板名称" prop="Name">
              <el-input v-model="form.Name" placeholder="请输入模板名称" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="纸张宽度(mm)" prop="PageWidth">
              <el-input-number v-model="form.PageWidth" :min="10" :max="300" placeholder="宽度" style="width: 100%"
                @change="handlePaperSizeChange" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="纸张高度(mm)" prop="PageHeight">
              <el-input-number v-model="form.PageHeight" :min="10" :max="100" placeholder="高度" style="width: 100%"
                @change="handlePaperSizeChange" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="状态">
              <el-switch v-model="form.StatusBool" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- Hiprint 设计器三列布局 -->
      <div class="hiprint-wrapper">
        <div class="hiprint-left">
          <div class="hiprint-col-title">拖拽元素</div>
          <div class="drag-item-panel">
            <div class="drag-group" v-for="group in dragGroups" :key="group.title">
              <div class="drag-group-title">{{ group.title }}</div>
              <div class="drag-group-items">
                <a
                  v-for="item in group.items"
                  :key="item.tid"
                  class="ep-draggable-item drag-item"
                  :tid="item.tid"
                  :title="'按住拖拽到设计区：' + item.title"
                >
                  <i :class="['drag-item-icon', item.icon, item.iconRotate ? 'icon-rotate-90' : '']"></i>
                  <span class="drag-item-label">{{ item.title }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="hiprint-center">
          <div class="hiprint-col-title">
            <span>设计区域</span>
            <div class="zoom-controls">
              <i class="el-icon-zoom-out" @click="changeScale(false)"></i>
              <span class="zoom-value">{{ (scaleValue * 100).toFixed(0) }}%</span>
              <i class="el-icon-zoom-in" @click="changeScale(true)"></i>
            </div>
          </div>
          <div class="card-design">
            <div id="hiprint-printTemplate" class="hiprint-printTemplate"></div>
          </div>
        </div>
        <div class="hiprint-right">
          <div class="hiprint-col-title">属性设置</div>
          <div class="params_setting_container">
            <div id="PrintElementOptionSetting"></div>
          </div>
        </div>
      </div>
      
    <!-- 预览 -->
    <print-preview ref="preView"/>
    </el-main>
  </el-container>
</template>

<script>
import { submit } from '@/api/base'
import labelProviders, { dragGroups } from '@/assets/printTemplate/provider'
import printPreview from './preview'
import printData from '@/assets/printTemplate/print-data'

export default {
  name: 'PrintTemplateEditor',
  components: { printPreview },
  data() {
    return {
      saving: false,
      form: {
        ID: 0,
        Name: '',
        Description: '',
        PageWidth: 70,
        PageHeight: 38,
        Config: '',
        StatusBool: true,
      },
      marginRight: 3.5,
      formRules: {
        Name: [{ required: true, message: '请输入模板名称', trigger: 'blur' }],
        PageWidth: [{ required: true, type: 'number', message: '请输入纸张宽度', trigger: 'blur' }],
        PageHeight: [{ required: true, type: 'number', message: '请输入纸张高度', trigger: 'blur' }],
      },
      hiprintInstance: null,
      templateId: null,
      dragGroups,
      scaleValue: 3,
      scaleMin: 1,
      scaleMax: 5,
    }
  },
  computed: {
    isEdit() {
      return !!this.templateId
    },
  },
  async mounted() {
    await this.loadPrintConfig()
    this.templateId = this.$route.query.id ? parseInt(this.$route.query.id) : null
    if (this.templateId) {
      await this.loadTemplateDetail()
    }
    this.$nextTick(() => {
      setTimeout(() => {
        this.initHiprint(this.templateId ? this.form.Config : null)
      }, 200)
    })
  },
  methods: {
    // 加载打印配置，作为新增模板时的宽高基础值
    async loadPrintConfig() {
      try {
        const res = await submit('/api/common/getCustomerParameter?key=BarCodePrintSetting')
        if (res.success && res.data) {
          const config = JSON.parse(res.data)
          this.form.PageWidth = config.paperWidth || 70
          this.form.PageHeight = config.paperHeight || 38
        }
      } catch (error) {
        console.error('获取打印配置失败', error)
      }
    },

    preView() {
      if (!this.hiprintInstance) {
        this.$message.warning('设计器尚未就绪，请稍后再试')
        return
      }
      const width = this.form.PageWidth - this.marginRight || 70
      const height = this.form.PageHeight || 38
      this.$refs.preView.show(this.hiprintInstance, printData, width, height)
    },
    // 加载模板详情（编辑模式）
    async loadTemplateDetail() {
      try {
        const { data, success } = await submit(`/api/printTemplate/get?id=${this.templateId}`)
        if (success && data) {
          this.form = {
            ID: data.ID,
            Name: data.Name || '',
            Description: data.Description || '',
            PageWidth: data.PageWidth || 70,
            PageHeight: data.PageHeight || 38,
            Config: data.Config,
            StatusBool: data.Status === 1,
          }
        }
      } catch (e) {
        console.error('获取模板详情失败', e)
        this.$message.error('获取模板详情失败')
      }
    },

    // 保存
    async handleSave() {
      try {
        await this.$refs.templateForm.validate()
      } catch {
        return
      }

      // 获取当前 hiprint 模板数据
      if (this.hiprintInstance) {
        try {
          const templateJson = this.hiprintInstance.getJson()
          if (templateJson) {
            this.form.Config = templateJson
          }
        } catch (e) {
          console.error('获取模板JSON失败', e)
        }
      }

      this.saving = true
      const params = {
        ID: this.form.ID,
        Name: this.form.Name,
        Description: this.form.Description,
        PageWidth: this.form.PageWidth,
        PageHeight: this.form.PageHeight,
        Config: JSON.stringify(this.form.Config),
        Status: this.form.StatusBool ? 1 : 0,
      }
      try {
        const { data, success } = await submit('/api/printTemplate/save', params)
        if (success) {
          this.$message.success('保存成功')
          // 保存成功后，由于页面不关闭，更新模板ID
          this.templateId = data.ID;
          this.form.ID = data.ID;
        }
      } catch (e) {
        console.error('保存模板失败', e)
      } finally {
        this.saving = false
      }
    },

    // 撤回
    handleUndo() {
      if (this.hiprintInstance) {
        this.hiprintInstance.undo()
      }
    },

    // 恢复
    handleRedo() {
      if (this.hiprintInstance) {
        this.hiprintInstance.redo()
      }
    },

    // 取消/返回
    handleCancel() {
      window.close()
    },

    // 纸张尺寸变化时更新设计器
    handlePaperSizeChange() {
      if (this.hiprintInstance) {
        const width = this.form.PageWidth - this.marginRight || 70
        const height = this.form.PageHeight || 38
        if (width > 0 && height > 0) {
          try {
            this.hiprintInstance.setPaper(width, height)
          } catch (e) {
            console.error('更新纸张尺寸失败', e)
          }
        }
      }
    },

    setOptionConfig(hiprint) {
      hiprint.setConfig({
        text: {
          tabs: [
            {
              name: '基础',
              options: [
                { name: "field", hidden: true }
              ]
            },
            {
              name: '样式',
              options: [
                { name: "borderTop", hidden: true },
                { name: "borderRight", hidden: true },
                { name: "borderLeft", hidden: true },
                { name: "borderBottom", hidden: true },
                { name: "backgroundColor", hidden: true },
                { name: "letterSpacing", hidden: true },
                { name: "borderWidth", hidden: true },
                { name: "lineHeight", hidden: true },
                { name: "FontColor", hidden: true },
                { name: "textDecoration", hidden: true },
                { name: "zIndex", hidden: true },
                { name: "widthHeightSync", hidden: true },
                { name: "textContentWrap", hidden: true },
                { name: "textContentVerticalAlign", hidden: true },
                { name: "transform", hidden: true },
                { name: "color", hidden: true },
                { name: "fontFamily", hidden: true },
                { name: "barColor", hidden: true },
              ]
            },
            {
              name: '边框',
              replace: true,
              options: []
            },
            {
              name: '高级',
              replace: true,
              options: []
            }
            // 样式、边框、高级 使用 hiprint 默认配置，不覆盖
          ],
        }
      })
    },

    // 初始化 Hiprint 设计器
    initHiprint(templateJson) {
      this.destroyHiprint()

      try {
        const hiprint = this.$hiprint
        if (!hiprint || !hiprint.init) {
          console.warn('hiprint 插件未正确加载')
          return
        }

        this.setOptionConfig(hiprint)

        // 1. 使用自定义 labelProvider 初始化
        const provider = labelProviders[0]
        // movingDistance=1：键盘/拖动最小步距 1pt（通过 init 设置，会被 hidraggable minMove 和键盘事件正确读取）
        hiprint.init({
          providers: [provider.f],
          movingDistance: 1
        })

        // 2. 构建左侧拖拽元素面板（推荐用法：自定义 HTML 拖拽项 + buildByHtml，tid 与设计元素对应）
        hiprint.PrintElementTypeManager.buildByHtml(this.$('.ep-draggable-item'))

        // 3. 创建 PrintTemplate 实例
        let templateOptions = {
          dataMode: 1,
          history: true,
          onDataChanged: (type, json) => {
            // console.log('模板变更', type, json)
          },
          settingContainer: '#PrintElementOptionSetting',
          paginationContainer: '.hiprint-printPagination'
        }

        if (templateJson) {
          templateOptions.template = JSON.parse(templateJson)
        } else {
          templateOptions.template = {}
        }

        const template = new hiprint.PrintTemplate(templateOptions)
        this.hiprintInstance = template

        // 4. 将设计器挂载到中心区域（不启用 grid）
        template.design('#hiprint-printTemplate')

        // 4.1 获取当前缩放比例，默认2.9，并应用
        this.scaleValue = template.editingPanel ? template.editingPanel.scale || 3 : 3
        template.zoom(this.scaleValue, true)

        // 5. 设置纸张尺寸
        const pageWidth = this.form.PageWidth - this.marginRight || 70
        const pageHeight = this.form.PageHeight || 38
        if (pageWidth > 0 && pageHeight > 0) {
          template.setPaper(pageWidth, pageHeight)
        }
      } catch (e) {
        console.error('初始化 hiprint 设计器失败', e)
      }
    },

    // 缩放设计区域
    changeScale(big) {
      let scaleValue = this.scaleValue
      console.log("scaleValue", scaleValue)
      if (big) {
        scaleValue += 0.1
        if (scaleValue > this.scaleMax) scaleValue = this.scaleMax
      } else {
        scaleValue -= 0.1
        if (scaleValue < this.scaleMin) scaleValue = this.scaleMin
      }
      if (this.hiprintInstance) {
        this.hiprintInstance.zoom(scaleValue, true)
        this.scaleValue = scaleValue
      }
    },

    // 销毁 Hiprint 设计器
    destroyHiprint() {
      if (this.hiprintInstance) {
        try {
          if (this.hiprintInstance.destroy) {
            this.hiprintInstance.destroy()
          }
          if (this.hiprintInstance.clear) {
            this.hiprintInstance.clear()
          }
        } catch (e) {
          console.error('销毁 hiprint 设计器失败', e)
        }
      }
      this.hiprintInstance = null
      const containers = ['#hiprint-printTemplate', '#PrintElementOptionSetting']
      containers.forEach(sel => {
        const el = document.querySelector(sel)
        if (el) el.innerHTML = ''
      })
    },
  },
  beforeDestroy() {
    this.destroyHiprint()
  },
}
</script>

<style lang="scss" scoped>
.editor-page {
  height: 100vh;
  display: flex;
  flex-direction: column;

  .el-header {
    height: 50px !important;
    padding: 0 20px;
    border-bottom: 1px solid #e4e7ed;
    display: flex;
    align-items: center;

    .editor-header {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .editor-title {
        margin: 0;
        font-size: 16px;
        color: #303133;
      }

      .editor-header-actions {
        display: flex;
        gap: 10px;

        .el-button {
          min-width: 150px;
          min-height: 40px;
        }

        .el-button-undo {
          margin-left: 0 !important;
          letter-spacing: 1px !important;
          background-color: #fff !important;
          color: #419EFF;
          border-color: #419EFF;
        }

        /* 按下（激活）状态 */
        .el-button-undo:active {
          background-color: #419EFF !important;
          color: #fff !important;
          border-color: #419EFF !important;
        }
      }
    }
  }

  .el-main {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 20px;
  }
}

// Hiprint 三列布局
.hiprint-wrapper {
  display: flex;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  margin-top: 10px;
  flex: 1;
  min-height: 400px;

  .hiprint-left {
    width: 200px;
    flex-shrink: 0;
    border-right: 1px solid #e4e7ed;
    display: flex;
    flex-direction: column;

    .drag-item-panel {
      flex: 1;
      overflow-y: auto;
      padding: 10px;
    }

    .drag-group {
      margin-bottom: 14px;

      .drag-group-title {
        font-size: 12px;
        font-weight: bold;
        color: #909399;
        margin-bottom: 8px;
        padding-left: 2px;
      }

      .drag-group-items {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
      }
    }

    // 可拖拽元素卡片：参考官方 hiprint 设计器拖拽交互
    .drag-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 64px;
      height: 60px;
      padding: 6px 4px;
      border: 1px solid #e4e7ed;
      border-radius: 6px;
      background: #fff;
      color: #606266;
      cursor: grab;
      user-select: none;
      text-decoration: none;
      transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);

      .drag-item-icon {
        font-size: 20px;
        color: #409eff;
        margin-bottom: 4px;
        line-height: 1;

        &.icon-rotate-90 {
          transform: rotate(90deg);
        }
      }

      .drag-item-label {
        font-size: 12px;
        text-align: center;
        white-space: nowrap;
      }

      &:hover {
        border-color: #409eff;
        color: #409eff;
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.25);
        transform: translateY(-2px);
      }

      &:active {
        cursor: grabbing;
      }
    }
  }

  .hiprint-center {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;

    .card-design {
      flex: 1;
      overflow: hidden;
      overflow-x: auto;
      overflow-y: auto;
    }
  }

  .hiprint-right {
    width: 280px;
    flex-shrink: 0;
    border-left: 1px solid #e4e7ed;
    display: flex;
    flex-direction: column;

    .params_setting_container {
      flex: 1;
      overflow-y: auto;
      padding: 4px;
    }
  }

  .hiprint-col-title {
    padding: 6px 10px;
    background: #f5f7fa;
    font-size: 18px;
    font-weight: bold;
    color: #606266;
    border-bottom: 1px solid #e4e7ed;
    flex-shrink: 0;
    display: flex;
    align-items: center;

    .zoom-controls {
      display: flex;
      align-items: center;
      gap: 4px;
      font-weight: normal;
      margin-left: 50px;

      i {
        cursor: pointer;
        font-size: 20px;
        color: #606266;
        padding: 2px;

        &:hover {
          color: #409EFF;
        }
      }

      .zoom-value {
        font-size: 18px;
        color: #303133;
        min-width: 36px;
        font-weight: 700;
        text-align: center;
      }
    }
  }
}

// Hiprint 全局样式覆盖已迁移至 /public/css/hiprint-overrides.css
</style>
